module.exports = __webpack_public_path__ + "images/pipeline-summit-2016-small.jpg";